
const StatusBadge = ({ status = "" }) => {
  const transformedStatus = status?.toLowerCase();
  const statusConfig = {
    true: { color: "bg-green-100 text-green-700", label: "Active" },
    draft: { color: "bg-yellow-100 text-yellow-700", label: "Draft" },
    false: { color: "bg-red-100 text-red-700", label: "Inactive" },
    expired: { color: "bg-gray-100 text-gray-700", label: "Expired" },
    submitted: { color: "bg-blue-100 text-blue-800", label: "Submitted" },
    shortlisted: {
      color: "bg-purple-100 text-purple-800",
      label: "Shortlisted",
    },
    under_review: {
      color: "bg-yellow-100 text-yellow-800",
      label: "Under Review",
    },
    interview: { color: "bg-indigo-100 text-indigo-800", label: "Interview" },
    offer_extended: {
      color: "bg-green-100 text-green-800",
      label: "Offer Extended",
    },
    hired: { color: "bg-emerald-100 text-emerald-800", label: "Hired" },
    rejected: { color: "bg-red-100 text-red-800", label: "Rejected" },
  };

  const config = statusConfig[transformedStatus] || {
    color: "bg-gray-100 text-gray-700",
    label: status,
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs capitalize font-medium ${config.color}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
